import { InfoCircleOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../../../redux/hooks.ts'
import { selectThemeStyle } from '../../../../features/setting/setting.slice.ts'
import Tooltip from 'antd/es/tooltip/index'
import { useIsMobile } from '../../../../common/hooks/use-is-mobile.ts'

export const TotalPnlDependentHeaderComponent = () => {
  const { t } = useTranslation()
  const themeStyle = useAppSelector(selectThemeStyle)
  const isMobile = useIsMobile()

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: themeStyle.marginXXS,
        width: '100%',
      }}
    >
      <span>{t('overall_ranking.ranking_table.columns.total_pnl')}</span>
      {!isMobile && (
        <Tooltip
          title={
            'Rankings use normalized PnL to ensure fair comparison across different deployment levels'
          }
        >
          <InfoCircleOutlined
            style={{
              color: themeStyle.colorIcon,
              marginLeft: themeStyle.marginXS,
              cursor: 'pointer',
            }}
          />
        </Tooltip>
      )}
    </div>
  )
}
